var map = {
	"./AmiPolymerDashboard.svg": 5651,
	"./Emailbox.svg": 5299,
	"./Messagebox.svg": 8101,
	"./Namebox.svg": 8090,
	"./aboutmelogo.png": 8116,
	"./adaniGroup.png": 5236,
	"./akshayAvatar.png": 690,
	"./curriculum.png": 433,
	"./gmail.svg": 5602,
	"./godrejDashboard.svg": 5538,
	"./graph-image.png": 9614,
	"./hotelManagementImage.svg": 5566,
	"./hotleManagement.png": 2137,
	"./hrdashboard.svg": 3784,
	"./hrdashboard2.svg": 2638,
	"./internDashboard.svg": 1896,
	"./jobsupport.png": 247,
	"./kidsdashboard.svg": 5249,
	"./ksrtc.png": 5756,
	"./linkedin.png": 8518,
	"./linkedin.svg": 7657,
	"./logo.svg": 2835,
	"./logoFooter.svg": 7906,
	"./noise.png": 8976,
	"./phone.svg": 5244,
	"./powerBiTraining.png": 7940,
	"./practical.png": 8713,
	"./projectImage.png": 6370,
	"./salesdashboard.svg": 5488,
	"./shravari-profile.png": 7907,
	"./telemedRxDashboard.svg": 1977,
	"./traveldashboard.svg": 459,
	"./websiteIcon.svg": 9551,
	"./whatsapp.svg": 4511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;